<!--
 * @LastEditTime: 2024-06-04 16:08:23
 * @LastEditors: heqing heqing@wiz.top
 * @Description: 照明一张图
-->
<template>
  <div class="left w-full h-full p-5px">
    <div class="h-1/3">
      <CategoryTitle title="设备状态监控"></CategoryTitle>
      <div class="flex flex-wrap justify-between mt-8px">
        <div v-for="(item, index) in deviceStatusList" :key="index" class="w-1/2 p-5px">
          <div class="status-item h-82px w-full p-10px text-14px text-white">
            <div class="flex flex-wrap justify-between">
              <div class="text-16px font-medium">{{ item.name }}</div>
              <div class="text-[#2ce1d9]">{{ item.online + item.offline }}</div>
            </div>
            <div class="flex flex-wrap justify-between">
              <img :src="item.pic" class="mr-5px w-42px" />
              <div class="mt-10px">
                <div class="mb-5px">
                  <span class="circle circle-1"></span>
                  <span>在线：</span>
                  <span>{{ item.online }}</span>
                </div>
                <div>
                  <span class="circle circle-2"></span>
                  <span>离线：</span>
                  <span>{{ item.offline }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="h-1/3 relative">
      <CategoryTitle title="设备能耗统计"></CategoryTitle>
      <div class="relative right-0 top-[-20px]">
        <DiyButtonGroup
          @button-click="getEnergyData"
          :value="energyValue"
          :list="['按时']"
          class="absolute right-0 top-0 z-999"
        ></DiyButtonGroup>
      </div>
      <div class="w-full h-[calc(100%-30px)]">
        <v-chart
          :options="energyAnalysisOptions"
          autoresize
          class="w-full h-full"
          ref="energyTrend"
        ></v-chart>
      </div>
    </div>
    <!-- <div class="h-1/3 relative">
      <CategoryTitle title="设备报警"></CategoryTitle>
      <i
        class="icon el-icon-d-arrow-right absolute right-0 top-0 text-[#fff] cursor-pointer"
        @click="toMore"
      ></i>
      <el-table
        :data="dataList"
        class="w-full h-[calc(100%-30px)] overflow-y-auto mt-10px"
        v-loading="tableLoading"
      >
        <el-table-column label="级别" prop="prLevel" width="60" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.prLevel === 1" class="text-[#feff00]">告警</span>
            <span v-if="scope.row.prLevel === 2" class="text-[#feb600]">严重</span>
            <span v-if="scope.row.prLevel === 3" class="text-red-500">致命</span>
          </template>
        </el-table-column>
        <el-table-column label="故障信息" prop="prDesc" show-overflow-tooltip></el-table-column>
        <el-table-column
          label="发生时间"
          prop="prAlarmtime"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="75px">
          <template slot-scope="scope">
            <div @click.stop="toDetail(scope.row)" class="cursor-pointer text-[#00BCC8]">查看</div>
          </template>
        </el-table-column>
      </el-table>
    </div> -->
    <div class="h-1/3 relative">
      <CategoryTitle title="碳排放统计"></CategoryTitle>
      <div class="relative right-0 top-[-20px]">
        <DiyButtonGroup
          @button-click="getCarbonStatistics"
          :value="carbonValue"
          :list="['按时']"
          class="absolute right-0 top-0 z-999"
        ></DiyButtonGroup>
      </div>
      <div class="w-full h-[calc(100%-30px)] flex flex-col">
        <div class="flex-1 flex p-10px items-center text-white text-18px">
          <div class="relative max-w-70px mr-10px">
            <div class="flex flex-col items-center justify-center">
              <span class="whitespace-nowrap overflow-hidden overflow-ellipsis max-w-70px">{{ carbonStatistics.rate.toFixed(2) }}<span class="text-12px">%</span></span>
              <span class="text-12px">减少碳排放</span>
            </div>
            <div class="absolute top-0 left-0 w-full h-full">

            </div>
          </div>
          <div class="flex-1">
            <div>
              <div class="flex justify-between items-center">
                <span>实际用电量</span>
                <span class="flex items-center"><span class="whitespace-nowrap overflow-hidden overflow-ellipsis max-w-80px">{{ carbonStatistics.sp3.toFixed(2) }}</span><span class="text-gray-200 text-12px">KW/H</span></span>
              </div>
              <Progress :percentage="70" startColor="#24292F" endColor="#1C77E3"></Progress>
            </div>
            <div class="mt-10px">
              <div class="flex justify-between items-center">
                <span>拓展电碳量</span>
                <span class="flex items-center"><span class="whitespace-nowrap overflow-hidden overflow-ellipsis max-w-80px">{{ carbonStatistics.carbon.toFixed(2) }}</span><span class="text-gray-200 text-12px">KG</span></span>
              </div>
              <Progress :percentage="50" startColor="#24292F" endColor="#1C77E3"></Progress>
            </div>
          </div>
        </div>
        <div class="flex-1 flex p-10px items-center text-white text-18px">
          <div class="relative max-w-70px mr-10px">
            <div class="flex flex-col items-center justify-center">
              <span>10.62 <span class="text-12px">%</span></span>
              <span class="text-12px">减少碳排放</span>
            </div>
            <div class="absolute top-0 left-0 w-full h-full">

            </div>
          </div>
          <div class="flex-1">
            <div>
              <div class="flex justify-between items-center">
                <span>实际能耗</span>
                <span>618.13 <span class="text-gray-200 text-12px">KW/H</span></span>
              </div>
              <Progress :percentage="70" startColor="#24292F" endColor="#28C3CA"></Progress>
            </div>
            <div class="mt-10px">
              <div class="flex justify-between items-center">
                <span>虚拟能耗</span>
                <span>153.29 <span class="text-gray-200 text-12px">KW/H</span></span>
              </div>
              <Progress :percentage="50" startColor="#24292F" endColor="#28C3CA"></Progress>
            </div>
          </div>
        </div>
        
      </div>
    </div>
    <AlarmsListDialog v-if="isShowAlarmsListDialog" class="w-800px h-500px" @refresh="refresh" />
    <AlarmDetailDialog
      v-if="isShowAlarmsDetailDialog"
      class="w-500px h-260px"
      @refresh="refresh"
      :propsData="rowData"
    />
  </div>
</template>

<script>
import { LightingDeviceApi, LightingApi } from '@wiz-api/huizhou2-business'
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import DiyButtonGroup from '../../../../cockpit-huizhou/components/global/DiyButtonGroup'
import AlarmsListDialog from './alarmsListDialog'
import AlarmDetailDialog from './alarmDetailDialog'
import Progress from './Progress.vue'
import * as echarts from 'echarts'

const lightingDeviceApi = new LightingDeviceApi()
const lightingApi = new LightingApi()

export default {
  name: 'lighting',
  components: {
    CategoryTitle,
    DiyButtonGroup,
    AlarmsListDialog,
    AlarmDetailDialog,
    Progress
  },
  data() {
    return {
      deviceStatusList: [
        {
          devType: 0,
          name: '传感器',
          total: 0,
          online: 0,
          offline: 0,
          pic: require('../../../assets/images/lighting/sensor.png'),
        },
        {
          devType: 1,
          name: '灯',
          total: 0,
          online: 0,
          offline: 0,
          pic: require('../../../assets/images/lighting/lamp.png'),
        },
        {
          devType: 2,
          name: '网关',
          total: 0,
          online: 0,
          offline: 0,
          pic: require('../../../assets/images/lighting/gateway.png'),
        },
        {
          devType: 3,
          name: '回路',
          total: 0,
          online: 0,
          offline: 0,
          pic: require('../../../assets/images/lighting/circuit.png'),
        },
      ],
      btnValue: '按时',
      carbonValue: '按时',
      energyValue: '按时',
      valMap: {
        '按时': 1,
        '按天': 2,
        '按月': 3
      },
      energyAnalysisOptions: {
        grid: {
          top: 40,
          left: 40,
          right: 10,
          bottom: 30,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {
          data: ['实际能耗', '虚拟能耗', '节能率'],
          textStyle: {
            color: '#fff'
          },
          top: 8,
          icon: 'rect',
          itemWidth: 8,
          itemHeight: 2
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLine: {
            lineStyle: {
              color: '#fff'
            }
          },
          axisLabel: {
            color: '#fff'
          }
        },
        yAxis: [
          {
            type: 'value',
            name: 'kw/h',
            nameTextStyle: {
              color: '#fff'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#fff'
              }
            },
            axisLabel: {
              color: '#fff'
            },
            splitLine: {
              lineStyle: {
                color: 'rgba(255, 255, 255, 0.1)'
              }
            },
            axisTick: {
              show: false
            }
          },
          {
            type: 'value',
            name: '%',
            nameTextStyle: {
              color: '#fff'
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: '#fff'
              }
            },
            axisLabel: {
              show: false,
              color: '#fff'
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: [
          {
            name: '实际能耗',
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              color: '#4AECEC',
              borderRadius: [5, 5, 0, 0]
            },
            data: [],
          },
          {
            name: '虚拟能耗',
            type: 'bar',
            barWidth: 10,
            itemStyle: {
              color: '#1F5587',
              borderRadius: [5, 5, 0, 0]
            },
            data: [],
          },
          {
            name: '节能率',
            type: 'line',
            yAxisIndex: 1,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: {
              color: '#4AC696',
              borderColor: '#fff'
            },
            lineStyle: {
              color: '#4AC696'
            },
            data: []
          }
        ]
      },
      energyOptions: {
        grid: {
          top: 40,
          left: 40,
          right: 10,
          bottom: 30,
        },
        legend: {
          show: true,
          data: ['KW/h'],
          textStyle: {
            color: 'rgba(255,255,255, 0.6)',
          },
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        color: ['#44f1ff'],
        xAxis: {
          type: 'category',
          data: [],
          axisLabel: {
            color: 'rgba(255,255,255,0.6)',
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: 'rgba(255,255,255,0.6)',
            fontSize: 12,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.1)',
            },
          },
        },
        series: [
          {
            name: 'KW/h',
            data: [],
            type: 'line',
            lineStyle: {
              color: '#0ca30c'
            },
            itemStyle: {
              opacity: 0
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#12DB12'
                },
                {
                  offset: 1,
                  color: 'rgba(255, 255, 255, 0)'
                }
              ])
            }
          },
        ],
      },
      tableLoading: false,
      dataList: [],
      isShowAlarmsListDialog: false,
      isShowAlarmsDetailDialog: false,
      rowData: {},
      carbonStatistics: {
        rate: 0,
        sp4: 0,
        carbon: 0,
        sp3: 0
      }
    }
  },
  created() {
    this.$emit('transferEvent', {
      toCom: {
        code: 'LightingDeviceList',
        origin: 'Lighting',
        name: '设备清单',
      },
      type: 'mainComponent',
    })
    this.buttonClick('按时')
    this.getCarbonStatistics('按时')
    this.getEnergyData('按时')
    this.getDeviceStatus()
    this.getEquipmentStatus()
    this.getAlarms()
  },
  methods: {
    async getEquipmentStatus() {
      const [err, res] = await lightingApi.getDeviceStatusStatistics()
      if (!err && res) {
        this.deviceStatusList[0].online = res.sensorOn
        this.deviceStatusList[0].offline = res.sensorOff
        this.deviceStatusList[1].online = res.lightOn
        this.deviceStatusList[1].offline = res.lightOff
        this.deviceStatusList[2].online = res.gatewayOn
        this.deviceStatusList[2].offline = res.gatewayOff
        this.deviceStatusList[3].online = res.loopsOn
        this.deviceStatusList[3].offline = res.loopsOff
      }
    },
    async getCarbonStatistics(val) {
      this.carbonValue = val
      const [err, res] = await lightingApi.getCO2Statistics({
        type: this.valMap[val]
      })
      if (!err && res) {
        this.carbonStatistics = res
      }
    },
    getEnergyData(val) {
      this.energyValue = val
      const type = this.valMap[val]
      this.getStatistics(type)
      this.getAnalysis(type)
    },
    async getStatistics(type) {
      const [err, res] = await lightingApi.getEnergyStatistics({
        type
      })
      if (!err && res) {
        this.energyOptions.xAxis.data = res.map(item => item.time)
        this.energyOptions.series[0].data = res.map(item => item.value)
      }
    },
    async getAnalysis(type) {
      const [err, res] = await lightingApi.getEnergyAnalysis({
        type
      })
      if (!err && res) {
        this.energyAnalysisOptions.xAxis.data = res.map(item => item.time)
        this.energyAnalysisOptions.series[0].data = res.map(item => item.sp3)
        this.energyAnalysisOptions.series[1].data = res.map(item => item.sp4)
        this.energyAnalysisOptions.series[2].data = res.map(item => item.rate)
      }
    },
    // 页签切换
    buttonClick(val) {
      this.btnValue = val
      this.$nextTick(() => {
        if (this.$refs.energyTrend) {
          this.$refs.energyTrend.resize()
        }
      })
      this.energyOptions.xAxis.data = []
      this.energyOptions.series[0].data = []
      if (val === '按时') {
        for (let i = 0; i < 24; i++) {
          const hour = i < 10 ? 0 + i : i
          this.energyOptions.xAxis.data.push(`${hour}:00`)
          this.energyOptions.series[0].data.push(Math.floor(Math.random() * 10))
        }
      } else if (val === '按天') {
        for (let i = 1; i <= 31; i++) {
          this.energyOptions.xAxis.data.push(`${i}日`)
          this.energyOptions.series[0].data.push(Math.floor(Math.random() * 20))
        }
      } else if (val === '按月') {
        for (let i = 1; i <= 12; i++) {
          this.energyOptions.xAxis.data.push(`${i}月`)
          this.energyOptions.series[0].data.push(Math.floor(Math.random() * 30))
        }
      }
    },
    // 设备状态监控
    async getDeviceStatus() {
      const [err, res] = await lightingDeviceApi.lightingDeviceStastic()
      if (!err) {
        this.deviceStatusList.map((item, index) => {
          if (item.devType === res[index].devType) {
            item.total = res[index].online + res[index].offline
            item.online = res[index].online
            item.offline = res[index].offline
          }
          return item
        })
      }
    },
    // 获取设备报警列表
    async getAlarms() {
      this.tableLoading = true
      const [err, res] = await lightingDeviceApi.getLightingDeviceAlarmList({
        body: {
          maxResultCount: 10,
          skipCount: 1,
        },
      })
      if (!err) {
        this.dataList = []
        this.dataList = res.items
      }
      this.tableLoading = false
    },
    // 查看更多
    toMore() {
      this.isShowAlarmsListDialog = true
    },
    // 详情
    toDetail(row) {
      this.isShowAlarmsDetailDialog = true
      this.rowData = row
    },
    // 刷新
    refresh(val) {
      this.isShowAlarmsListDialog = false
      this.isShowAlarmsDetailDialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
.status-item {
  background: url('../../../assets/images/lighting/bg_zbzr.png') no-repeat;
  background-size: 100% 100%;
}
.circle {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #ff8900;
  margin-right: 10px;
  position: relative;
  top: -3px;
}
.circle-1 {
  background: #45d696;
}
</style>
